module.exports = __webpack_public_path__ + "static/media/twitter.99ba74e0.svg";